<template>
  <b-field :label="label" :horizontal="isHorizontal">
    <b-select
      placeholder="Select the file manager"
      icon="account"
      v-model="fileManagerId"
      expanded
    >
      <option value="" selected>All</option>
      <option
        v-for="person in staff"
        :key="person.id"
        :value="person.id"
      >{{person.name}}</option>
    </b-select>
  </b-field>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'FileManagerSelect',
  props: ['label', 'value', 'isHorizontal'],
  data () {
    return {
      fileManagerId: this.value,
      hideLabel: false
    }
  },
  computed: {
    ...mapState(['staff'])
  },
  watch: {
    fileManagerId () {
      this.$emit('value-changed', this.fileManagerId)
    },
    value () {
      this.fileManagerId = this.value
    }
  },
  created () {
    this.$store.dispatch('getStaff')
  }
}
</script>

<style scoped>

</style>
